import * as yup from "yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getBase64 } from "../../../utils/stringUtils";
import { FaCircleNotch } from "react-icons/fa";
import { IoAttachOutline, IoSend } from "react-icons/io5";
import {
  MULTIMEDIA_MIME_TYPES,
  FILE_ALREADY_EXISTS,
} from "../../../utils/constants";
import Toaster from "../../../components/common/Toaster";
import authService from "../../../services/authService";
import chatService from "../../../services/chatService";
import _ from "lodash";

const schema = yup.object({
  message: yup.string(),
});

const MessageFooter = ({ room, fileRef, files, setFiles, onClick }) => {
  const user = authService.getCurrentUser();

  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      if (!isLoading) {
        if (data.message || files.length > 0) {
          setIsLoading(true);

          if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
              const file = await getBase64(files[i]);
              const content = await file.split(",")[1];

              const item = {
                file_name: files[i].name,
                content,
              };

              await chatService.saveAttachmentAsync(room.id, item);
            }

            setFiles([]);
          }

          if (data.message !== "") {
            const value = data.message.replace(/\r\n|\r|\n/g, "<br />");

            const message = {
              sender_id: user.user_id,
              room_id: room.id,
              text_message: value,
            };

            setValue("message", "");

            await chatService.saveMessageAsync(message);
          }

          setIsLoading(false);
        }
      }
    } catch (ex) {
      if (ex.response && ex.response.data.message === FILE_ALREADY_EXISTS) {
        Toaster.Error("File already exists.");
      } else {
        Toaster.Error("Something went wrong.");
      }

      setIsLoading(false);
    }
  };

  const handleEnterPress = (e) => {
    if (e.key === "Enter" && e.shiftKey === false) {
      e.preventDefault();
      const data = { message: e.target.value };
      handleSubmit(onSubmit(data));
    }
  };

  const handleFiles = (e) => {
    const temp_files = Array.from(e.target.files);
    const union = _.union(files, temp_files);
    const data = Object.assign([], union);
    setFiles(data);
  };

  return (
    <div className="py-5 px-8 border-t border-gray-100">
      <form
        className="flex flex-row items-center"
        onSubmit={handleSubmit(onSubmit)}
      >
        <input
          type="file"
          multiple
          ref={fileRef}
          accept={MULTIMEDIA_MIME_TYPES}
          className="hidden"
          onChange={(e) => handleFiles(e)}
        />
        <IoAttachOutline
          className="text-gray-400 text-2xl cursor-pointer"
          onClick={() => onClick()}
        />
        <div className="flex flex-row items-center w-full rounded-lg border h-16 mx-5 border-gray-200">
          <div className="w-full">
            <textarea
              name="message"
              id="message-textarea"
              className="border border-transparent bg-transparent w-full focus:outline-none focus:ring-0 placeholder-gray-400 text-gray-600 dark:text-gray-300 resize-none text-sm h-16 flex items-center"
              placeholder="Write a message..."
              onKeyPress={handleEnterPress}
              {...register("message")}
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className="disabled:opacity-70 disabled:cursor-not-allowed"
        >
          {isLoading && (
            <FaCircleNotch className="text-blue-400 animate-spin text-xl" />
          )}
          {!isLoading && <IoSend className="text-blue-500 text-xl" />}
        </button>
      </form>
    </div>
  );
};

export default MessageFooter;
